<template>
  <div>
    <px-view-header title="Moedas" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div v-if="hasModuleGerencia">
      <px-cadastro-configuracao-moedas :moedas="moedas" @change="getMoedas"/>
    </div>
    <div v-if="loading" class="mt-3">
      <px-circular-loading/>
    </div>
    <div v-else class="mt-3">
      <v-card class="card-shadow rounded-card mb-3" v-for="moeda in moedas" :key="moeda.id">
        <v-card-text class="text--primary">
          <v-row dense no-gutters align="center" justify="center">
            <v-col cols="12" sm="6">
              {{ moeda.moeda }} &middot; {{ description(moeda.moeda) }}
              <span v-if="moeda.codigoInterno">&middot; {{ moeda.codigoInterno }}</span>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
              <v-btn icon v-if="!isReal(moeda.moeda)" @click="onClickDelete(moeda)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <px-confirm-dialog ref="confirm"/>
    </div>
  </div>
</template>

<script>
import ConfiguracaoMoedaService from '@/modules/configuracoes-moedas/configuracao-moeda.service';
import { MoedasPadroes, Moeda } from 'px-business-components';
import { mapGetters } from 'vuex';
import CadastroConfiguracaoMoedas
  from '@/modules/configuracoes-moedas/CadastroConfiguracaoMoedas.vue';

export default {
  data() {
    return {
      loading: false,
      moedas: [MoedasPadroes.BRL],
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Moedas' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    description() {
      return moeda => Moeda.keys[moeda].description;
    },
    isReal() {
      return moeda => moeda === Moeda.keys.BRL.key;
    },
  },
  methods: {
    getMoedas() {
      this.loading = true;
      ConfiguracaoMoedaService.getConfiguracoesMoedas()
        .then((response) => {
          this.moedas = [MoedasPadroes.BRL, ...response.data];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeMoeda(moeda) {
      this.loading = true;
      ConfiguracaoMoedaService.deleteConfiguracaoMoeda(moeda.id)
        .then(() => this.getMoedas())
        .finally(() => {
          this.loading = false;
        });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta moeda?',
        'Fornecedores não poderão mais responder com esta moeda.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.removeMoeda(item);
        });
    },
  },
  created() {
    this.getMoedas();
  },
  components: {
    pxCadastroConfiguracaoMoedas: CadastroConfiguracaoMoedas,
  },
};
</script>
